module.exports = __webpack_public_path__ + "assets/retina_SquareAboutCircleDetailed.adfe5333455198171f92de0a5304ffb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareAboutCircleDetailed.png
// module id = 717
// module chunks = 0